// @ts-nocheck
import { callApi } from 'services/api/api'
import { toastStore } from 'stores/toast'
import { TOAST_TYPE } from 'utils/constants'
import { baseURL } from 'services/api/apiConfig'
import { appSelected } from 'stores/navigation'

let selectedApplication = 'physician'
appSelected.subscribe(value => {
  if (value.toLocaleLowerCase() === 'app') {
    selectedApplication = 'app'
  } else {
    selectedApplication = 'physician'
  }
})

/**
 * Gets the list of available org librarys.
 */
// eslint-disable-next-line no-unused-vars
export const getOrgLibraryGrid = async ({ id, section, body }) => {
  try {
    return callApi(`${baseURL}/organization-library/${selectedApplication}/grid`, 'POST', body)
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error getting organization library list')
    return {}
  }
}

/**
 * Export the org library data
 */

export const postOrgLibraryExport = async ({ body }) => {
  try {
    return await callApi(`${baseURL}/organization-library/${selectedApplication}/export`, 'POST', body)
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error exporting org library data')
    throw error
  }
}

/**
 * Gets the list of available org librarys.
 */
export const getOrgLibraryList = async () => {
  try {
    return callApi(`${baseURL}/organization-library/${selectedApplication}`, 'GET')
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error getting organization library list')
    return {}
  }
}

export async function getOrganizationLibraryFilter(body) {
  try {
    return await callApi(`${baseURL}/organization-library/${selectedApplication}/filters `, 'POST', body)
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error getting filters for Organization Library')
    throw error
  }
}
